module.exports = __webpack_public_path__ + "img/horizontal_6_3_8019.a0139f55.png";